<div>
	<span class="label">{{fieldOptions?.label || fieldOptions?.DisplayText || 'No title'}} : </span>

	<div *ngIf="fieldOptions.triggerModal  && isEditing"
		 class="public-record-field">
		<img *ngIf="fieldOptions.triggerModal"
			 [ngClass]="{'public-record-none ': fieldOptions.publicRecordMultiple === 'none'}"
			 src="assets/img/datamaster.png" />

		<span class="value "
			[ngClass]="{
              'multiple': isMultiple
            }"
			  (click)="openDetailModal()"
			  data-toggle="tooltip"
			  data-placement="top"
			  [title]="PUBLIC_RECORD_MESSAGES_TOOLTIP[fieldOptions.publicRecordMultiple]">

			{{ fieldOptions.pipe ? (values[0] | date:'medium':'UTC-7') : values.join(fieldOptions.charConcat ? fieldOptions.charConcat : '/') }}
			<i *ngIf="fieldOptions.triggerModal && isMultiple"
			   class="fa fa-archive"
			   aria-hidden="true">
			</i>
			<i *ngIf="fieldOptions.triggerModal  && fieldOptions.publicRecordMultiple === 'single'"
			   class="fa fa-file"
			   aria-hidden="true">
			</i>
		</span>
	</div>

	<span *ngIf="!fieldOptions.triggerModal || !fieldOptions.publicRecordMultiple || !isEditing"
		  class="value">
		  {{ fieldOptions.pipe ? (values[0] | date:'medium':'UTC-7') : values.join(fieldOptions.charConcat ? fieldOptions.charConcat : '/') }}
	</span>

</div>
